import React from 'react';

import RiskProfileLoader from '../risk_profile_loader';

import '../risk_profile_table.css';

const FiveByFiveRiskProfileTable = (props) => {

  const { profile, riskRatingDict, likelihoodConversionToView, translations, loading } = props;
  const { current_risk_rating, final_risk_rating } = translations;

  return (
    <div className="risk-profile-table">
      {
        loading && <RiskProfileLoader/>
      }
      <table>
        <tr>
          <th rowSpan="2" colSpan="2"></th>
        </tr>
        <tr className="blue">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
        </tr>
        { 
          profile && profile.map((obj, i)=>{
            const likelihood = likelihoodConversionToView[obj.likelihood.split(':')[0]]
            const i_index = i + 1
            return (
              <tr key={i_index}>
                <td className="alice-blue">{likelihood}</td>
                <td className="blue">{i_index}</td>
                { 
                  obj.ratings.map((item, j)=>{
                    var j_index = j + 1
                    return (
                      <td key={i_index + "-" + j_index} className={ "ratings rating-" + i_index + "-" + j_index}>
                        <div className="rating">{riskRatingDict[likelihood][item.rating].label}</div>
                        <div className="risk-count-div">
                          <div className="risk-label">{current_risk_rating}: </div>
                          <div><span className="risk-count">{item.current_count}</span></div>
                        </div>
                        <div className="risk-count-div">
                          <div className="risk-label">{final_risk_rating}: </div>
                          <div><span className="risk-count">{item.final_count}</span></div>
                        </div>
                      </td>
                    )
                  })
                }
              </tr>
            )
          })
        }
      </table>
    </div>
  )
}

export default FiveByFiveRiskProfileTable;



// WEBPACK FOOTER //
// ./src/views/risk_profile_tables/teck/five_by_five_risk_profile_table.js